import React from 'react';
import PropTypes from 'prop-types';
import Button from 'kepler/lib/components/Button';
import Card from 'kepler/lib/components/Card';
import getContent from '../lib/dictionaryFetcher';

/**
 * render all the categories for desktop or laptop screensize.
 * @param {*} props
 */
const DefaultCategoriesFeatured = props => {
  const { featured, category, callback } = props;

  if (!featured) return null;

  const heading = getContent(
      'merchanthub',
      `categories.title.suggested.${category}`,
      category
    ),
    description = getContent(
      'merchanthub',
      `apps.${featured}.featured.description`,
      undefined,
      { useHTML: true }
    ),
    title = getContent('merchanthub', `apps.${featured}.title`);

  return (
    <div id="tools-featured">
      <h2 className="tools-category-heading">{heading}</h2>
      <Card className={`featured-card ${featured}`}>
        <div className="featured-card-icon" />
        <div className="featured-card-content">
          <h3>
            <span className="featured-card-icon-sm" />
            {title}
          </h3>
          <p>{description} </p>
          <Button
            id={`btn-featured-${featured}`}
            type="secondary"
            size="sm"
            onClick={() =>
              callback(featured, {
                fptiLink: `featured:${featured}`
              })
            }
          >
            {getContent('merchanthub', `apps.${featured}.button`, '')}
          </Button>
        </div>
      </Card>
    </div>
  );
};

DefaultCategoriesFeatured.propTypes = {
  featured: PropTypes.string,
  category: PropTypes.string,
  callback: PropTypes.func
};

export default DefaultCategoriesFeatured;
